import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../services/user/user';
import {UserService} from '../../services/user/user.service';
import {Carrier} from 'src/app/services/carrier/carrier';
import {LoadingService} from '../../services/loading/loading.service';
import {HhgOnlineBookShipmentService} from '../hhg-online-book-shipment/hhg-online-book-shipment.service';
import {UserProfileService} from 'src/app/services/user-profile/user-profile.service';
import {AlertService} from '../../services/alert/alert.service';
import {BookShipmentRequest} from '../hhg-online-book-shipment/book-shipment';
import AppConstants, {NameAndAddressRecordType, BookShipmentStatus, BusinessType} from 'src/app/shared/common-components/AppConstants';
import {BehaviorSubject} from 'rxjs';
import {takeWhile} from 'rxjs';
import {CarrierService} from '../../services/carrier/carrier.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {BillOfLadingService} from '../../services/bill-of-lading/bill-of-lading.service';
import {ReQueryFormData} from 'src/app/shared/common-components/common-structure';
import {RatesSroMasterService} from '../../services/rates-sro-master/rates-sro-master.service';
import {concatMap, map} from 'rxjs/operators';
import {FrtShipAccessorialsService} from '../../services/frt-ship-accessorials/frt-ship-accessorials.service';
import {FrtAccessorialsMasterService} from '../../services/frt-accessorials-master/frt-accessorials-master.service';
import {ShipmentDeliveryDataService} from '../../services/shipment-delivery-data/shipment-delivery-data.service';
@Component({
    selector: 'app-shipment-control',
    templateUrl: './shipment-control.component.html',
    styleUrls: ['./shipment-control.component.css'],
    standalone: false
})
// This component is used for shipment control review for both Freight & HHG
export class ShipmentControlComponent implements OnInit, OnDestroy {

  private observer$ = new BehaviorSubject(true);
  shipmentType: String = '';
  showDeliveryReportButton = false;
  carrier: Carrier;
  public modalRef: BsModalRef;
  isCarrierView = false; // use this field and set it to true if its carrier view
  shipmentDetailsData: any = {};
  shipperInfo: User | any;
  shipmentCostInfo: any = {};
  shipmentInfo: any = {};
  bookShipmentInfo: any = {};
  ratesHhgInfo: any = {};
  rateTypesInfo: any = {};
  ratesSroInfo: any = {};
  shipmentLabelInfo: any = {};
  originAddress: String = '';
  destinationAddress: String = '';
  originCountry: String = '';
  destinationCountry: String = '';
  agencyInfo: any = {};
  carrierOrganizationInfo: any = {};
  bolNumber: any;
  bookshipmentid = '';
  selectedShipmentType: any;
  bookShipments: any = null;
  originCity: string;
  originState: string;
  originZip: string;
  destinationCity: string;
  destinationState: string;
  destinationZip: string;
  originUspsZipId: number;
  destinationUspsZipId: number;
  shipmentConfirmedUserInfo: any = {};
  oneTimeOnly: any;
  delivertExceptionCode: string;

  constructor(private loader: LoadingService, private router: Router, private route: ActivatedRoute, private carrierService: CarrierService, private alertService: AlertService,
              private onlineBookShipmentService: HhgOnlineBookShipmentService,
              private billOfLadingService: BillOfLadingService, private ratesSroMasterService: RatesSroMasterService,
              private userProfileService: UserProfileService, private modalService: BsModalService,
              private frtShipAccessorialsService: FrtShipAccessorialsService, private userService: UserService,
              private frtAccessorialsMasterService: FrtAccessorialsMasterService,
              private shipmentDeliveryDataService:ShipmentDeliveryDataService) {
  }

  ngOnInit() {
/*    this.userService.getCurrentUserObservable().subscribe(
      currentUser => {
        const user = currentUser;
        const roleIds = user.roles.map(x => x.id);
        const allowedRoleIds = [4, 5, 6];
        if (roleIds.some(r => allowedRoleIds.indexOf(r) >= 0)) {
        }
    });*/
    const bookshipmentid = this.route.snapshot.queryParamMap.get('bookshipmentid');
    this.bookshipmentid = bookshipmentid;
    this.onlineBookShipmentService.setShipmentsObservable(null); // remove from storage if any
    this.getShipmentInfoByBookShipmentId(bookshipmentid);
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.loadCarrierView(currentUser);
    }, (error) => {
      this.loader.hide();
    });

    window.scrollTo(0, 0);
  }

  loadCarrierView(currentUser) {
    if (AppConstants.isNotNullCondition(currentUser)) {
      const carrierRoles = AppConstants.getCarrierRolesArray();
      if (currentUser.roles.some(role => carrierRoles.indexOf(role.name) >= 0)) {
        this.isCarrierView = true;
      }
    }
  }

  /**
   * @description To get shipment details by book shipment id
   * @param bookShipmentId:Book Shipment id of the shipment
   */
  getShipmentInfoByBookShipmentId(bookShipmentId) {
    this.loader.show();
    this.onlineBookShipmentService.getShipmentInfoByBookShipmentId(bookShipmentId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      this.shipmentDetailsData = data;
      this.loadInitialData();
      if (this.isCarrierView && this.shipmentType === 'FRT' && (this.shipmentDetailsData.bookShipmentsEntity.bookingStatus === 'Booked' || this.shipmentDetailsData.bookShipmentsEntity.bookingStatus === 'Complete')) {
        this.showDeliveryReportButton = true;
      } else {
        this.showDeliveryReportButton = false;
      }
      
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('Error retrieving shipment details');
    });
  }

  /**
   * @description Prepopulates selected data from the previous page
   */
  loadInitialData() {

    this.shipmentInfo = this.shipmentDetailsData;
    console.log(this.shipmentInfo);
    this.bookShipmentInfo = this.shipmentInfo.bookShipmentsEntity;
    if (this.bookShipmentInfo.oneTimeOnly !== null) {
      this.oneTimeOnly = this.bookShipmentInfo.oneTimeOnly;
    } else {
      this.oneTimeOnly = 0;
    }
    console.log(this.oneTimeOnly);
    this.shipmentType = this.bookShipmentInfo.shipmentType.substr(0, 3) === 'HHG' ? 'HHG' : 'FRT';
    this.ratesSroInfo = this.shipmentInfo.ratesSroMasterEntity;
    this.shipmentCostInfo = this.shipmentInfo.hhgShipmentsCostInfoEntity === null && this.bookShipmentInfo.shipmentType === BusinessType.FRT ?
      this.shipmentInfo.frtShipmentsCostInfoEntity : this.shipmentInfo.hhgShipmentsCostInfoEntity;
    this.ratesHhgInfo = this.shipmentCostInfo ? this.shipmentCostInfo.ratesHhgEntity : this.ratesHhgInfo;
    this.rateTypesInfo = this.ratesHhgInfo ? this.ratesHhgInfo.rateTypesEntity : this.rateTypesInfo;
    this.shipmentLabelInfo = this.shipmentInfo.shipmentsLabelInfoEntity;
    this.shipperInfo = this.bookShipmentInfo.userEntity;
    this.loadCarrierDetails(this.shipmentCostInfo.carrierId);
    const organizationEntity = this.bookShipmentInfo.organizationEntity;
    if (AppConstants.isNotNullCondition(organizationEntity) && AppConstants.isNotNullCondition(organizationEntity.agencyCustomerEntity)) {
      this.agencyInfo = organizationEntity.agencyCustomerEntity.agencyMasterEntity;
    }
    this.getGeneratedBolNumber(this.shipmentInfo.shipmentsInfoId, this.shipmentType);

    //    this.getSelectedShipmentType(this.bookshipmentid);
    const addressInfo = this.shipmentInfo.nameAndAddressEntity;
    addressInfo.forEach(addressObj => {
      const country = addressObj.countryEntity.stateCountryName;
      const address1 = AppConstants.isNotNullCondition(addressObj.addressLine1) ? (addressObj.addressLine1) : '';
      const address2 = AppConstants.isNotNullCondition(addressObj.addressLine2) ? (addressObj.addressLine2) : '';
      const city = AppConstants.isNotNullCondition(addressObj.city) ? (addressObj.city + ',') : '';
      const state = AppConstants.isNotNullCondition(addressObj.stateEntity) ? addressObj.stateEntity.stateCountryCode2Digit : '';
      const zip = AppConstants.isNotNullCondition(addressObj.zipCode) ? ('(' + addressObj.zipCode + ')') : '';

      if (addressObj.recordType === NameAndAddressRecordType.ORIGIN) {
        if (country === 'UNITED STATES') {
          this.originAddress = city + state + zip;
        } else {
          this.originAddress = address1 + address2;
        }
        this.originCity = AppConstants.isNotNullCondition(addressObj.city) ? addressObj.city : '';
        this.originState = AppConstants.isNotNullCondition(addressObj.stateEntity) ? addressObj.stateEntity.stateCountryCode2Digit : '';
        this.originZip = AppConstants.isNotNullCondition(addressObj.zipCode) ? addressObj.zipCode : '';
        this.originCountry = country;
      } else if (addressObj.recordType === NameAndAddressRecordType.DESTINATION) {
        if (country === 'UNITED STATES') {
          this.destinationAddress = city + state + zip;
        } else {
          this.destinationAddress = address1 + address2;
        }
        this.destinationCity = AppConstants.isNotNullCondition(addressObj.city) ? addressObj.city : '';
        this.destinationState = AppConstants.isNotNullCondition(addressObj.stateEntity) ? addressObj.stateEntity.stateCountryCode2Digit : '';
        this.destinationZip = AppConstants.isNotNullCondition(addressObj.zipCode) ? addressObj.zipCode : '';
        this.destinationCountry = country;
      }
    });
    if (this.bookShipmentInfo.oneTimeOnly !== 1 && (this.bookShipmentInfo.bookingStatus === BookShipmentStatus.EXPIRED || this.bookShipmentInfo.bookingStatus === BookShipmentStatus.REFUSED)) {
      this.setUspsZipId();
    }
    if (AppConstants.isNotNullCondition(this.shipmentInfo.updateId) && this.bookShipmentInfo.bookingStatus === BookShipmentStatus.ACCEPTED ||
      this.bookShipmentInfo.bookingStatus === BookShipmentStatus.ACCEPTED_WITH_QUALIFICATION || this.bookShipmentInfo.bookingStatus === BookShipmentStatus.CANCELLED) {
      this.getShipmentConfirmedUserInfo(this.shipmentInfo.updateId);
    }
  }

  getShipmentConfirmedUserInfo(updatedUserId) {
    this.loader.show();
    this.userService.getUserByUserId(updatedUserId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(user => {
        // console.log(user);
      this.shipmentConfirmedUserInfo = user;
      this.loader.hide();
    }, error => {
      this.loader.hide();
      // console.log('There was an error retrieving shipment last updated user id', JSON.stringify(error));
      this.alertService.error('Error retrieving shipment confirmed user info');
    });
  }

  setUspsZipId() {
    this.ratesSroMasterService.getLocation(this.originCity, this.originZip, this.originState).pipe(concatMap(data1 => this.ratesSroMasterService.getLocation(this.destinationCity, this.destinationZip, this.destinationState).pipe(map(data2 => ([data1, data2]))
    ))).subscribe(finalData => {
      console.log(finalData[0].length);
      this.originUspsZipId = finalData[0].uspsZipId;
      this.destinationUspsZipId = finalData[1].uspsZipId;
    }, error => {
      this.loader.hide();
      // console.log('Error while getting the USPS details =>' + error);
      this.alertService.error('Error while getting the USPS address details');
    });

  }

  getGeneratedBolNumber(shipmentsInfoId, shipmentType) {
    // this.loader.show();
    this.billOfLadingService.getBolNumberByShipmentId(shipmentsInfoId, shipmentType).subscribe(data => {
      if (AppConstants.isNotNullCondition(data)) {
        this.bolNumber = data.billOfLadingNbr;

        if(this.shipmentType === 'FRT'){//load exception Code
          this.getFrtExceptionCode(this.shipmentDetailsData.bookShipmentsEntity.organizationId, data.bolDetailsId);
        }
      }
      // this.loader.hide();
    }, error => {
      // this.loader.hide();
      // console.log('There was an error checking bol number =>' + JSON.stringify(error));
      this.alertService.error('Error checking bol number');
    });
  }
  getFrtExceptionCode(organizationId: any, bolDetailsId: any) {
    this.shipmentDeliveryDataService.getShipmentDeliveryWithExceptionCodeByFrtBolDetailsIdAndOrganizationId(bolDetailsId, organizationId)
    .pipe(takeWhile(() => this.observer$.value))
    .subscribe(
      (data: any)=> {
       this.delivertExceptionCode = (data?.frtDeliveryException !== null && data?.frtDeliveryException?.length > 0) ? data?.frtDeliveryException : '';
      },
      (error:any) => {
        console.log(error);
      }
    );
  }

  /**
   * @description To get carrier details
   * @param carrierId
   */
  loadCarrierDetails(carrierId) {
    if (carrierId) {
      this.loader.show();
      this.carrierService.getCarrierByCarrierId(carrierId).subscribe(data => {
        if (AppConstants.isNotNullCondition(data)) {
          this.carrier = data;
          if (this.carrier.carrierContactInfoEntity.length !== 0 ) {
            for (let i = 0; i < this.carrier.carrierContactInfoEntity.length; i++) {
              if (this.carrier.carrierContactInfoEntity[i].contactType === this.shipmentType) {
              this.carrierOrganizationInfo = this.carrier.carrierContactInfoEntity[i];
              break;
              } else {
                this.carrierOrganizationInfo = this.carrier.organizationEntity;
              }
            }
          } else {
          this.carrierOrganizationInfo = this.carrier.organizationEntity;
          }
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        // console.log('There was an error retrieving carrier details =>' + error);
        this.alertService.error('Error retrieving TSP details');
      });
    }
  }

  /**
   * @description To go back to online booking page
   */
  backToOnlineBooking() {
    let navPage = '';
    if (this.bookShipmentInfo.shipmentType === BusinessType.FRT) {
      navPage = 'frtbookshipment';

    } else {
      navPage = 'hhgbookshipment';
    }
    this.router.navigate(['/', navPage], {
      queryParams:
        {bookshipmentid: this.shipmentInfo.bookShipmentsEntity.bookShipmentId}
    });
  }

  /**
   * @description Reactivate FRT Book Shipment
   * the function will take shipmentId to process reactivating FRT bookshipment.
   */
  reactivateShipment() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you sure, you want reactivate a shipmentID ' + this.bookShipmentInfo.bookShipmentId + ' ? Click Yes to proceed, No to go back.';
    this.modalRef.content.body = 'Shipper: ' + this.shipperInfo.firstName + ' ' + this.shipperInfo.lastName + '<br>Customer: ' + this.agencyInfo.agencyBureauName;
    this.modalRef.content.title = 'Reactivate FRT Shipment';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        if (this.bookShipmentInfo.shipmentType === BusinessType.FRT) {
          this.billOfLadingService.reactiveShipment(this.shipmentInfo.bookShipmentsEntity.bookShipmentId).subscribe(
            data => {
              this.router.navigate(['/', 'shipmentcontrolreview'],
                {queryParams: {bookshipmentid: this.shipmentInfo.bookShipmentsEntity.bookShipmentId, shipmentType: this.shipmentType}});
                this.ngOnInit();
            }, error => {
              console.log(error);
            }
          );
        }
      }
    });
  }

  reactivateShipmentFropmCancelToBooked() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you sure, you want reactivate a shipmentID' + this.bookShipmentInfo.bookShipmentId + ' from Cancelled to Booked ? Click Yes to proceed, No to go back.';
    this.modalRef.content.body = 'Shipper: ' + this.shipperInfo.firstName + ' ' + this.shipperInfo.lastName + '<br>Customer: ' + this.agencyInfo.agencyBureauName;
    this.modalRef.content.title = 'Reactivate FRT Shipment';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        if (this.bookShipmentInfo.shipmentType === BusinessType.FRT) {
          let reactivatedFRTShipment : any = {
            bookShipmentID: this.shipmentInfo.bookShipmentsEntity.bookShipmentId,
            bolNumber: this.bolNumber
          };
          this.billOfLadingService.reactiveShipmentFromCancelledtoBooked(reactivatedFRTShipment).subscribe(
            data => {
              this.router.navigate(['/', 'shipmentcontrolreview'],
                {queryParams: {bookshipmentid: this.shipmentInfo.bookShipmentsEntity.bookShipmentId, shipmentType: this.shipmentType}});
                this.ngOnInit();
            }, (error) => {
              console.log(error);
            }
          );
        }
      }
    });
  }

  /**
   * @description Duplication Shipment
   */
  DuplicateShipment() {
    const shipmentReq = new BookShipmentRequest();
    shipmentReq.shipmentInfo = this.shipmentInfo;
    let bookShipmentId: any;
    this.onlineBookShipmentService.duplicateShipment(shipmentReq).pipe(takeWhile(() => this.observer$.value)).subscribe(shipmentId  => {
      this.loader.show();
      bookShipmentId = shipmentId;
      const duplicateShipment = 1;
      // console.log('Created duplicate shipment ', bookShipmentId);
      if (bookShipmentId !== null &&  bookShipmentId !== undefined) {
            const navPage = 'frtbookshipment' ;
            this.router.navigate(['/', navPage], {
            queryParams: {bookshipmentid: bookShipmentId, duplicateShipment: duplicateShipment}
          });
      } else {
        this.alertService.error('Error occurred in creating duplication Shipment Details');
      }
    }, (error) => {
      this.alertService.error('Error occurred in creating duplication Shipment Details');
    });
  }

  /**
   * @description Saves shipment details
   */
  saveShipment() {
    const shipmentReq = new BookShipmentRequest();
    shipmentReq.shipmentInfo = this.shipmentInfo;
    if (shipmentReq.shipmentInfo.bookShipmentsEntity.bookingStatus === 'Cancelled' ) {
      shipmentReq.control = BookShipmentStatus.CANCELLED ;
    }
    this.onlineBookShipmentService.saveShipment(shipmentReq).pipe(takeWhile(() => this.observer$.value)).subscribe(result => {
      this.loader.show();
      // console.log('Saved Shipment details');
      this.loader.hide();
      this.alertService.success('Successfully updated the status');
    }, error => {
      this.loader.hide();
      console.log(JSON.stringify(error));
      this.alertService.error('Error updating the status');
    });

  }

  /**
   * @description To cancel booking and update back-end
   */
  cancelShipment() {
    const bookingStatus = this.shipmentInfo.bookShipmentsEntity.bookingStatus;
    if (bookingStatus != BookShipmentStatus.CANCELLED) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to cancel this shipment?';
      this.modalRef.content.title = 'Shipment Cancellation';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        // console.log('results', result.obj);
        if (result.obj === true) {
          // console.log('cancel shipment');
          this.shipmentInfo.bookShipmentsEntity.bookingStatus = BookShipmentStatus.CANCELLED;
          this.saveShipment();
        }
      });
    } else {
      this.alertService.warn('Shipmemt is already in Cancelled status.');
    }
  }

  requeryShipment() {
    const key = 'shipmentId';
    const value = this.shipmentInfo.shipmentsInfoId;
    sessionStorage.setItem(key, value);
    const frtQueryData = new ReQueryFormData();
    frtQueryData.pickupDate = new Date(this.shipmentInfo.moveDate) < new Date() ? new Date() : new Date(this.shipmentInfo.moveDate);
    frtQueryData.estimatedMileage = this.shipmentInfo.miles;
    frtQueryData.estimatedWeight = this.shipmentInfo.weight;
    frtQueryData.sroId = this.shipmentInfo.sroMasterId;
    // frtQueryData.sroType = types.find(x => x.name === this.shipmentInfo.ratesSroMasterEntity.sroType);
    frtQueryData.sroType = this.shipmentInfo.ratesSroMasterEntity.sroType;
    frtQueryData.originId = {
      uspsZipId: this.originUspsZipId,
      zipCode: this.originZip,
      cityName: this.originCity,
      stateAbbrev: this.originState
    };
    frtQueryData.asyncOriginSearchString = this.originZip;
    frtQueryData.asyncDestinationSearchString = this.destinationZip;
    frtQueryData.destinationId = {
      uspsZipId: this.destinationUspsZipId,
      zipCode: this.destinationZip,
      cityName: this.destinationCity,
      stateAbbrev: this.destinationState
    };
    frtQueryData.estimatedCuFt = this.shipmentInfo.shipmentCubicFeet;
    this.getAccessorialsList(this.shipmentInfo.shipmentsInfoId, frtQueryData);
  }

  getAccessorialsList(shipmentsInfoId, frtQueryData) {
    this.loader.show();
    this.frtShipAccessorialsService.findByShipment(shipmentsInfoId)
      .pipe(takeWhile(() => this.observer$.value)).subscribe((data: any) => {
      if (AppConstants.isNotNullCondition(data)) {
        const accessorials = [];
        data.forEach(accessorial => {
          // console.log('Accessorial=', accessorial);
          if (accessorial.updateProgram === 'FRT-query-page') {
            const obj = {
              accessorial: {
                frtAccessorialsId: accessorial.frtAccessorialsId,
                accessorialCode: accessorial.frtAccessorialsMasterEntity.accessorialCode,
                accessorialDescription: accessorial.frtAccessorialsMasterEntity.accessorialDescription
              },
              units: accessorial.quantity,
              unitDescription: accessorial.frtAccessorialsMasterEntity.ratesAccessorialsUnitsEntity != null ? accessorial.frtAccessorialsMasterEntity.ratesAccessorialsUnitsEntity.userDisplay : null,
              usage: accessorial.usage
            };
            accessorials.push(obj);
          }
        });
        frtQueryData.accessorials = accessorials;
      }
    }, error => {
      this.loader.hide();
      console.log('There was an error retrieving accessorials by shipment id' + error);
      this.alertService.error('Error retrieving accessorials');
    }, () => {
      this.loader.hide();
      console.log('REQuerydata=', frtQueryData);
      frtQueryData.sroType = {name: frtQueryData.sroType};
      this.ratesSroMasterService.frtRateQueryFormState.next(frtQueryData);
      this.router.navigate(['/', 'freightquery'], {});
    });
  }

  /**
   * @description get selectedShipmentType from DB by bookShipmentId
   */

  /*
  getSelectedShipmentType(bookShipmentId: string) {
      this.loader.show();
      setTimeout(() => {
          this.billOfLadingService.getselectedShipmentTypeByBookShipmentId(bookShipmentId).subscribe(data => {
                  console.log('selectedShipmentType = ' + data);
                  this.selectedShipmentType = data;
                  this.loader.hide();
          },
          error => {
              this.loader.hide();
              console.log('There was an error while retreiving the selectedShipmentType from DB =>' + JSON.stringify(error));
              this.alertService.error('Error while retreiving the  selectedShipmentType');
          });
      }, 20000);
  }
  */

  printBillOfLading() {
    // console.log('in printBillOfLadingFromControl ');
    let employeeLastName = '';
    if (AppConstants.isNotNullCondition(this.shipmentLabelInfo) && this.bookShipmentInfo.shipmentType !== 'FRT') {
      employeeLastName = this.shipmentLabelInfo.employeeLastName;
    }
    this.router.navigate(['/', 'viewDocumentPackage'], {
      queryParams:
        {shipmentId: this.shipmentInfo.shipmentsInfoId, bookshipmentid: this.bookshipmentid,
          selectedShipmentType: this.bookShipmentInfo.shipmentType, employeeLastName: employeeLastName, status: this.bookShipmentInfo.bookingStatus}
    });
  }
  /**
   * navigates the user to shipment delivery report route
   */
  navigateToShipmentDeliveryReport() {
    this.router.navigate(['/', 'shipmentDelivery'], { queryParams: { shipmentInfoId: this.shipmentDetailsData.shipmentsInfoId, organizationId: this.shipmentDetailsData.bookShipmentsEntity.organizationId }});
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}
